





















import { mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import Leasing from '~/components/car/classifieds/view/partials/finance/Leasing.vue'
import Installments from '~/components/car/classifieds/view/partials/finance/Installments.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CTabs from '~/components/shared/configurable/tab/CTabs.vue'
import CTab from '~/components/shared/configurable/tab/CTab.vue'
import { defineComponent } from '~/utils/nuxt3-migration'

enum FinanceMethod {
  INSTALLMENTS = 'installments',
  LEASING = 'leasing'
}

export default defineComponent({
  components: {
    Installments,
    CCard,
    Leasing,
    CTabs,
    CTab
  },
  props: {
    activeTab: { type: Number, default: 1 }
  },
  mounted() {
    if (this.finance && this.finance.options) {
      const { numberOfInstallments, downpayment } = this.installments
      if (numberOfInstallments || downpayment || downpayment === 0) {
        this.selectedFinanceMethod = FinanceMethod.INSTALLMENTS
        this.activeTabInternal = 0
      }
    } else if (this.selectedLeasingOption) {
      this.selectedFinanceMethod = FinanceMethod.LEASING
      this.activeTabInternal = 1
    }
  },
  data() {
    return {
      selectedFinanceMethod: FinanceMethod.INSTALLMENTS,
      activeTabInternal: 0
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      finance: state => state.classified.finance,
      leasing: state => state.classified.leasing,
      selectedLeasingOption: state => state.leasing.option,
      installments: state => state.installments
    }),
    installmentsFinanceMethodIsSelected() {
      return this.selectedFinanceMethod === FinanceMethod.INSTALLMENTS
    },
    hasLeasingOptions() {
      return this.leasing && this.leasing.options
    },
    hasFinanceOptions() {
      return this.finance && this.finance.options
    },
    cardTitle() {
      if (this.hasLeasingOptions && this.hasFinanceOptions) {
        return null
      } else if (this.hasLeasingOptions) {
        return 'Leasing'
      } else if (this.hasFinanceOptions) {
        return this.$i18n.t('installments')
      }
      return null
    }
  },
  watch: {
    activeTab() {
      this.activeTabInternal = this.activeTab
    }
  },
  methods: {
    selectFinanceMethod(selectedTab: number) {
      if (selectedTab === 0) {
        this.selectedFinanceMethod = FinanceMethod.INSTALLMENTS
      } else {
        this.selectedFinanceMethod = FinanceMethod.LEASING
      }
    }
  }
})
